'use strict';
module.exports = require('./Slider.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/slider/index.js
// module id = 58
// module chunks = 7